package uk.co.nickthecoder.shaders

import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.shapes.Mesh

actual class UGradientProgram : UProgram(VERTEX, FRAGMENT) {

    private val colorLocation = getUniformLocation("color")
    private val toColorLocation = getUniformLocation("toColor")

    fun begin(viewMatrix: Matrix, modelMatrix: Matrix, color: Color, toColor: Color) {
        begin(viewMatrix, modelMatrix)
        setUniform(colorLocation, color)
        setUniform(toColorLocation, toColor)
    }

    actual companion object {

        private val instance = UGradientProgram()

        actual fun draw(
            mesh: Mesh,
            viewMatrix: Matrix, modelMatrix: Matrix,
            color: Color, toColor: Color
        ) {
            with(instance) {
                begin(viewMatrix, modelMatrix, color, toColor)
                draw(mesh)
                end()
            }
        }
    }

}

private const val VERTEX = """
attribute vec2 position;
attribute float u;

uniform mat3 viewMatrix;
uniform mat3 modelMatrix;

varying float fragmentU;

void main() {
    fragmentU = u;
    gl_Position = vec4( viewMatrix * modelMatrix * vec3(position, 1.0), 1.0);
}  
"""
private const val FRAGMENT = """
precision highp float;

varying float fragmentU;

uniform vec4 color;
uniform vec4 toColor;

void main() {
    gl_FragColor = color * (1.0-fragmentU) + toColor * fragmentU;
}
"""
